module.exports = __webpack_public_path__ + "img/b17.9ca84e08.jpg";